import { Node, mergeAttributes, type CommandProps } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    expandable: {
      insertExpandable: () => ReturnType;
    };
  }
}

export const ExpandableSummary = Node.create({
  name: 'expandableSummary',
  group: 'block',
  content: 'inline*',
  defining: true,

  parseHTML() {
    return [{ tag: 'summary' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'summary',
      mergeAttributes(HTMLAttributes, { class: 'rich-text-expandable-summary' }),
      0,
    ];
  },
});

export const ExpandableContent = Node.create({
  name: 'expandableContent',
  group: 'block',
  content: 'block+',
  defining: true,

  parseHTML() {
    return [{ tag: 'div[data-expandable-content]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-expandable-content': '',
        class: 'rich-text-expandable-content',
      }),
      0,
    ];
  },
});

export const Expandable = Node.create({
  name: 'expandable',
  group: 'block',
  content: 'expandableSummary expandableContent',
  defining: true,

  addAttributes() {
    return {
      open: {
        default: true,
        parseHTML: (element) => element.hasAttribute('open'),
        renderHTML: (attributes) => (attributes.open ? { open: '' } : {}),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'details[data-expandable]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'details',
      mergeAttributes(HTMLAttributes, { 'data-expandable': '', class: 'rich-text-expandable' }),
      0,
    ];
  },

  addCommands() {
    return {
      insertExpandable:
        () =>
        ({ commands }: CommandProps) =>
          commands.insertContent({
            type: this.name,
            attrs: { open: true },
            content: [
              { type: 'expandableSummary', content: [] },
              {
                type: 'expandableContent',
                content: [{ type: 'paragraph' }],
              },
            ],
          }),
    };
  },
});

export function buildExpandableExtension() {
  return [ExpandableSummary, ExpandableContent, Expandable];
}
